import React, { useEffect } from 'react';

function ImageData({ fileId, onDataChange }) {
    useEffect(() => {
        if (fileId) {
            fetch(`/api/imageinfo/${fileId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    const { url, fileid, filename } = data;
                    /* const { width, height } = data.videoinfo.original.video_stream; */
                    onDataChange(url, fileid, filename); // Вызов функции-колбэка для установки стейтов в родительском компоненте
                })
                .catch(error => {
                    // Обработка ошибок
                    console.error(error);
                });
        }
    }, [fileId, onDataChange]);

    return <div>{/* Component has mounted. */}</div>;
}

export default ImageData;